function datehour(date,timestring) {
    var dummyDate = "1/1/2000";
    var timeDiff = (new Date(dummyDate + " " + date)).getTime() - (new Date(dummyDate + " " + timestring)).getTime();
    var seconds = ~~(timeDiff/1000);
    var hour = ~~(seconds/60/60);
    var min = ~~((seconds - 60*60*hour) / 60);
    return hour.pad()+":"+min.pad();
  }
//import axios from 'axios'
export default {
    /*
    * Services Mutations
    */
    
    services_set_list: (state,payload) => {
        state.servicesList=payload
    },
    services_set_loading: (state,payload) => {
        state.isServicesLoading=payload
    },
    /*
    * Door To Door Mutations
    */
    
    doortodoor_set_list: (state,payload) => {

            state.doorToDoorList=payload

    },
    doortodoor_add_to_list: (state,payload) => {
        //console.log(state.doorToDoorlist)
        for (var i in payload) {
            state.doorToDoorList.push(payload[i])
          }
    },
    doortodoor_set_trip: (state,payload) => {
        state.doorToDoorTrip=payload
    },
    doortodoor_set_stop: (state,payload) => {
        state.doorToDoorStop=payload
    },
    doortodoor_set_loading: (state,payload) => {
        state.isDoorToDoorLoading=payload
    },
    doortodoor_set_loading_add: (state,payload) => {
        state.isDoorToDoorLoadingAdd=payload
    },

    /*
    * LocalBus Mutations
    */
    localbus_stops: (state,payload) => {
        state.localBusList=payload
    },
    /*
    * Transfer Mutations
    */
    go_to_step: (state,payload) => {
    state.transfer.current_step = payload
    },
    transfer_set_ar: (state,payload) => {
        state.transfer.ar = payload
    },
    transfer_set_date_a: (state,payload) => {
        state.transfer.date_a = payload
    },
    transfer_set_time_a: (state,payload) => {
        state.transfer.time_a = payload
    },
    transfer_set_date_r: (state,payload) => {
        state.transfer.date_r = payload
    },
    transfer_set_time_r: (state,payload) => {
        state.transfer.time_r = payload
    },
    transfer_set_from: (state,payload) => {
        state.transfer.from = payload
    },
    transfer_from_items: (state,payload) => {
        state.transfer.from_items=payload
    },
    transfer_set_to: (state,payload) => {
        state.transfer.to = payload
    },
    transfer_set_people: (state,payload) => {
        state.transfer.people = payload
    },
    transfer_to_items: (state,payload) => {
        state.transfer.to_items=payload
    },
    transfer_find: (state,payload) => {
        state.transfer.price=payload.price
        state.transfer.totalprice=payload.total
        state.transfer.people =payload.people
        state.transfer.status = payload.status
    },
    transfer_extras: (state,payload) => {
        state.transfer.extras=payload
    },
    selected_extras: (state,payload) => {
        state.transfer.selected_extras=payload
    },
    transfer_set_first_name: (state,payload) => {
        state.transfer.first_name=payload
    },
    transfer_set_last_name: (state,payload) => {
        state.transfer.last_name=payload
    },
    transfer_set_phone: (state,payload) => {
        state.transfer.phone=payload
    },
    transfer_set_notes: (state,payload) => {
        state.transfer.notes=payload
    },
    transfer_people_add: (state,payload) => {
        if (payload == 0) {
        state.transfer.people++
        } else if (state.transfer.people < payload ) {
            state.transfer.people++
        }
    },
    transfer_people_remove: (state) => {
        if (state.transfer.people > 1) {
            state.transfer.people--
          }
    },
    transfer_status: (state) => {
    
        if ((state.transfer.people > 0) && (state.transfer.date != null) && (state.transfer.time != null) && (state.transfer.from != null) && (state.transfer.to != null)) {
                return true
            } else {
                return false
            }
    },
    transfer_book_set_saving: (state,payload) => {
        state.isBookSaving=payload
    },
    transfer_book: (state) => {

        //console.log(state)


        state.isBookSaving=true   
        if (!state.doorToDoorTrip.direction_id) {
            state.transfer.date_a=state.doorToDoorTrip.date+' '+datehour(state.doorToDoorStop.arrival_time,"01:00:00")
            state.transfer.trip=state.doorToDoorTrip.long_name_inv  
        } else {
            state.transfer.date_a=state.doorToDoorTrip.date+' '+datehour(state.doorToDoorStop.departure_time,"00:00:00")
            state.transfer.trip=state.doorToDoorTrip.long_name  
        }
        
        fetch('https://marketplace.italyservices.it/martinimultimedia/transfer/book',
        {
            method:'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(state.transfer)
        })
  .then(response => response.json())
  .then(json => console.log(json))
  .catch(err =>{
    if(err=="server")return
    //console.log(err);
})
.finally(() => (
    state.isBookSaving=false
))
    }


}